import React from "react";
import { Link } from "react-router-dom";
import { useLazyQuery } from "@apollo/client";
import { FORGOT_PASSWORD } from "@ugg/shared/api/graphql/queries";
import { AppRoutes } from "@ugg/shared/routes/app-routes";

export default function EmailSentConfirmation(props) {
  const { emailConfirmation, setEmailConfirmation } = props;

  const [sendPasswordResetEmail] = useLazyQuery(FORGOT_PASSWORD, {
    context: { clientName: "auth-api" },
    fetchPolicy: "network-only",
    errorPolicy: "all",
  });

  const handleResend = () => {
    sendPasswordResetEmail({ variables: { email: emailConfirmation } });
  };

  return (
    <div>
      <div className="text-white text-[30px] font-bold font-barlow mb-[20px]">Check Your Email</div>
      <div className="mb-[36px] text-lavender-50 text-[14px] font-inter">
        Check your <span className="text-white font-bold">{emailConfirmation}</span> inbox for the password reset
        link. Depending on your filter settings, it may go to Spam.
      </div>
      <div className="flex gap-[12px]">
        <Link
          to={AppRoutes.HOME}
          className="btn-blue w-full max-w-[144px] h-[36px] !text-[13px] flex items-center justify-center"
        >
          Done
        </Link>
        <button
          type="button"
          className="w-full max-w-[144px] h-[36px] rounded-[3px] bg-lavender-500 hover:bg-lavender-600 text-white text-[13px] font-semibold"
          onClick={() => setEmailConfirmation(null)}
        >
          Start Over
        </button>
      </div>
    </div>
  );
}
